import ErrMessage from "../../core/ErrMessage";
import { useFilter } from "../../../fetch/fetch.filter";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter";
import Icon from "../../core/image/Icon";
import { IconDots, IconFilePencil } from "@tabler/icons-react";

const FilterIcon = ({ id }: { id: string }) => {
  const { filter, isLoading, isError } = useFilter(id, EMPTY_FILTER);
  if (isLoading) return <IconDots />;
  if (isError) return <ErrMessage message={isError.message} />;
  if (!filter.iconUrl) return <IconFilePencil />;
  return <Icon src={filter.iconUrl} size={6} />;
};
export default FilterIcon;
